import { useCallback, useEffect, useRef, useState } from "react"

import { OTRModuleList } from "../../components/Lists/OTRModuleList"
import { OTRModuleModel, OTRModuleModelDTO, OTRModuleModel_Resp, PartnerDataType } from "../../models/OTRModuleModel"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"

import {
  Box,
  FormControl,
  Grid,
  LinearProgress,
} from "@mui/material"
import useAuth from "../../context/AuthProvider"
import { config } from "../../Constants"
import { compactString, collectInvalidOtrImportDateFields, formatInvalidOtrImportDateMessage, formatOtrImportDate, formatUtcToLocal, hasOtrImportExcelRowData, isEmptyOrUndefined, isInvoiceNumber, isNanOrZero, isOtrImportDateCellBlank, readXlsxFile, toCurrency, writeXlsxFile } from "../../helper/utils"
import moment from "moment"
import { bool, boolean, number } from "yup"
import Swal from "sweetalert2"
import { FastField } from "formik"
import { GridSelectionModel, GridSortModel } from "@mui/x-data-grid-pro"
import {
  clientList,
  columnList,
  excelExportTypes,
  // excelItems,
  similarList,
  taxTypeList,
  transactionTypeList,
} from "./constants"
import ImportStatusDialog from "../../components/Elements/ImportStatusPopup"
import { CorrectedformatCurrency } from "../../helper/currencyFormatter"
import { apiClient } from "../../helper/api"
// OTR import duplicate-detection disabled 2026-07-29 (Dream Team).
// Blocked/missed transactions outweigh rare true duplicates (caught downstream).
// Kept for revisit with improved matching (e.g. don't treat missing/optional values as match criteria).
// Dialog components + helpers remain in repo; wire-up archived below in handleImportXlsx.
/*
import { OTRRemovedQueueRestoreDialog, MatchedRemovedItem } from "../../components/Elements/OTRRemovedQueueRestoreDialog"
import {
  OTRImportInFileDuplicateDialog,
  OTRImportExistingDuplicateDialog,
  MatchedExistingOtrItem,
} from "../../components/Elements/OTRImportDuplicateDialogs"
import {
  OTRImportCombinedConflictDialog,
  type CombinedConflictChoice,
} from "../../components/Elements/OTRImportCombinedConflictDialog"
import {
  buildOtrImportDuplicatePayload,
  findInFileDuplicateGroups,
  filterInFileDuplicatesKeepFirst,
  type InFileDuplicateGroup,
} from "./otrImportDuplicateKey"
*/

export const OpenTaxReport = () => {
  const { user } = useAuth()
  const token = user?.token
  const [loading, setloading] = useState(false)

  const initValue: OTRModuleModel_Resp = {
    items: [],
    totalCount: 0,
    pageCount: 0,
    pageSize: 25,
    currentPage: 0,
  }
  const [dataOTR, setDataOTR] = useState<OTRModuleModel[]>(initValue.items)
  const [currentPage, setCurrentPage] = useState(initValue.currentPage)
  const [pageSize, setPageSize] = useState(initValue.pageSize)
  const [totalCount, setTotalCount] = useState(initValue.totalCount)
  const [sortField, setSortField] = useState<string>("invDate")
  const [sortDirection, setSortDirection] = useState<string>("desc")
  const [selectedRows, setSelectedRows] = useState<OTRModuleModel[]>([]);
  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
  const [status, setstatus] = useState(false);
  const [openImportStatusDialog, setOpenImportStatusDialog] = useState(false);
  const isImportCompleted = useRef<string>("");
  // Archived with import duplicate-detection disable (2026-07-29 Dream Team) — restore with dialog imports above.
  /*
  const [openRemovedQueueDialog, setOpenRemovedQueueDialog] = useState(false);
  const [removedQueueMatchedItems, setRemovedQueueMatchedItems] = useState<MatchedRemovedItem[]>([]);
  const [removedQueueMatchedIds, setRemovedQueueMatchedIds] = useState<number[]>([]);
  const [removedQueueTotalImport, setRemovedQueueTotalImport] = useState(0);
  const pendingImportRef = useRef<{
    items: OTRModuleModel[];
    file: File | null;
    matchedItems: MatchedRemovedItem[];
  } | null>(null);
  const inFileDupResolverRef = useRef<((c: "skip" | "all" | "cancel") => void) | null>(null);
  const existingDupResolverRef = useRef<((c: "skip" | "all" | "cancel") => void) | null>(null);
  const [inFileDupDialogOpen, setInFileDupDialogOpen] = useState(false);
  const [inFileDupGroups, setInFileDupGroups] = useState<InFileDuplicateGroup[]>([]);
  const [existingDupDialogOpen, setExistingDupDialogOpen] = useState(false);
  const [existingDupMatches, setExistingDupMatches] = useState<MatchedExistingOtrItem[]>([]);
  const combinedConflictResolverRef = useRef<((choice: CombinedConflictChoice | "cancel") => void) | null>(null);
  const [combinedConflictDialogOpen, setCombinedConflictDialogOpen] = useState(false);
  const [combinedConflictDupMatches, setCombinedConflictDupMatches] = useState<MatchedExistingOtrItem[]>([]);
  const [combinedConflictRemovedItems, setCombinedConflictRemovedItems] = useState<MatchedRemovedItem[]>([]);
  const [combinedConflictTotalImport, setCombinedConflictTotalImport] = useState(0);
  */
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  /*
  const finishInFileDuplicateChoice = useCallback((choice: "skip" | "all" | "cancel") => {
    const fn = inFileDupResolverRef.current;
    inFileDupResolverRef.current = null;
    setInFileDupDialogOpen(false);
    fn?.(choice);
  }, []);

  const finishExistingDuplicateChoice = useCallback((choice: "skip" | "all" | "cancel") => {
    const fn = existingDupResolverRef.current;
    existingDupResolverRef.current = null;
    setExistingDupDialogOpen(false);
    fn?.(choice);
  }, []);

  const finishCombinedConflictChoice = useCallback((choice: CombinedConflictChoice | "cancel") => {
    const fn = combinedConflictResolverRef.current;
    combinedConflictResolverRef.current = null;
    setCombinedConflictDialogOpen(false);
    fn?.(choice);
  }, []);
  const getMatchKey = useCallback((row: { policyNumber?: string; invoiceNumber?: string; stateId?: number; client?: string; transactionTypeId?: number; transactionType?: string; taxType?: string; taxAmt?: string | number; grossPremium?: string; invDate?: string; effectiveDate?: string; expirationDate?: string }) => {
    const str = (v: string | number | undefined) => (v === undefined || v === null ? "" : String(v)).trim();
    const dateNorm = (v: string | undefined) => {
      const s = str(v);
      if (!s) return "";
      if (s.length >= 10 && s.indexOf("-") !== -1) return s.slice(0, 10);
      return s;
    };
    const numNorm = (v: string | number | undefined) => {
      if (v === undefined || v === null) return "";
      const s = str(v).replace(/,/g, "").replace(/\$/g, "");
      const n = parseFloat(s);
      if (isNaN(n)) return s;
      return n.toFixed(2);
    };
    const intNorm = (v: string | number | undefined) => {
      if (v === undefined || v === null) return "";
      const n = parseInt(String(v).trim(), 10);
      return isNaN(n) ? str(v) : String(n);
    };
    return [
      str(row.policyNumber),
      str(row.invoiceNumber),
      intNorm(row.stateId),
      str(row.client),
      intNorm(row.transactionTypeId),
      str(row.transactionType),
      str(row.taxType),
      numNorm(row.taxAmt),
      numNorm(row.grossPremium),
      dateNorm(row.invDate),
      dateNorm(row.effectiveDate),
      dateNorm(row.expirationDate),
    ].join("|");
  }, []);
  */

  const [taxFeeList, setTaxFeeList] = useState<Record<string, string[]>>({})
  const [stateList, setStateList] = useState<string[]>([])
  const [filterModel, setFilterModel] = useState<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>({ items: [], logicOperator: 'and' });

  const handleFilterModelChange = useCallback((newFilterModel: any) => {
    setFilterModel(newFilterModel);
    // Reset to page 1 when filters change
    setCurrentPage(0);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      await fetchOTRData({
        pageNumber: 1, // Always start from page 1 when filters are applied
        pageSize: pageSize,
        sort: sortDirection,
        field: sortField,
        filters: filterModel
      });
    };
    
    if (filterModel.items.length > 0) {
      fetchData();
    } else {
      // When no filters, reload all data from page 1
      fetchData();
    }
  }, [filterModel, pageSize, sortDirection, sortField]);

  async function checkProcessStatusOriginal() {
    const intervalTime = 5000; // 5 seconds
    const maxTime = 30000; // 30 seconds
    const startTime = Date.now();
    // Wait for 2 seconds before continuing
    await new Promise(resolve => setTimeout(resolve, 5000));

    const intervalId = setInterval(async () => {
      try {

        if (isImportCompleted.current === "In Progress") {
          // Import status monitoring removed
        }

        if (isImportCompleted.current === "Completed" || isImportCompleted.current === "Not Importing") {
          // setStatus("completed");

          isImportCompleted.current = 'Completed';
          clearInterval(intervalId);
        } else if (Date.now() - startTime >= maxTime) {
          // setStatus("timeout");

          isImportCompleted.current = 'Timeout';
          clearInterval(intervalId);
        }
      } catch (error) {
        console.error("Error fetching process status:", error);
      }
    }, intervalTime);

    // Stop checking after 30 seconds to avoid indefinite looping
    if (isImportCompleted.current === 'In Progress') {
      setTimeout(() => {
        if (Date.now() - startTime >= maxTime) {
          clearInterval(intervalId);

          isImportCompleted.current = 'Timeout';
          // setStatus("timeout");
        }
      }, maxTime);
    }
  }

  async function checkProcessStatus() {
    let tempStatus = "In Progress";
    const intervalTime = 5000; // 5 seconds
    const maxTime = 40000; // 30 seconds
    const startTime = Date.now();

    const intervalId = setInterval(async () => {
      try {
        if (Date.now() - startTime >= maxTime) {
          await new Promise(resolve => setTimeout(resolve, 3000));
          isImportCompleted.current = "Timeout";
          tempStatus = "Timeout";
          clearInterval(intervalId);
          return;
        }
        if (isImportCompleted.current === "In Progress") {
          getDataOTR();
        }
        if (isImportCompleted.current === "Completed" || isImportCompleted.current === "Not Importing") {
  
          isImportCompleted.current = "Completed";
          tempStatus = "Completed";
          await new Promise(resolve => setTimeout(resolve, 2000));
          handleCloseImportStatusDialog();
          clearInterval(intervalId);
        }
        if (isImportCompleted.current === "") {
          getDataOTR();
          clearInterval(intervalId);
        }
      } catch (error) {
        console.error("Error fetching process status:", error);
      }
    }, intervalTime);
  }


  const fetchOTRData = async ({ 
    pageSize = 25, 
    pageNumber = 1, 
    sort = "desc", 
    field = "invDate",
    filters
  }: { 
    pageSize?: number, 
    pageNumber?: number, 
    sort?: string, 
    field?: string,
    filters?: { items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }
  }) => {
    setloading(true)
    
    const requestBody = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      field: field,
      sort: sort,
      filterModel: filters || filterModel
    };
    
    const res = await apiClient(`/OpenTaxReport/getOpenTaxReport`, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }),
      body: JSON.stringify(requestBody)
    }).finally(() => {
      setloading(false)
    })

    // Handle the response
    if (!res?.data?.getData_Resp) {
      console.error('No getData_Resp array found in response', res?.data);
      return;
    }
    
    const updates = res.data.getData_Resp.map((item: OTRModuleModel, index: number) => ({
      rowNum: (index + 1).toString(),
      ...item,
    }));
    
    setDataOTR(updates);
    
    // Update pagination state if available
    if (res.data.totalCount !== undefined) {
      setTotalCount(res.data.totalCount);
    }
    
    if (res.data.currentPage !== undefined) {
      setCurrentPage(res.data.currentPage - 1); // Convert 1-based to 0-based for MUI DataGrid
    }
  }
  const updateOTRData = async (items: OTRModuleModel[], action: number, file: File | null = null) => {

    const itemsJson = JSON.stringify(items, null, 2);

    const formData = new FormData();
    formData.append('openTaxReport', itemsJson);
    if (file) {
      formData.append('missingFile', file);
    }
    

    
    setloading(true)
    const res = await apiClient(`/OpenTaxReport/SaveOrUpdate`, {
      method: "POST",
      headers: new Headers({
        // 'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      // body: JSON.stringify(items),
      body: formData
    }).finally(() => {
      setloading(false)
    })
    
    if (!res?.data) return

    if (action === 1) {
      isImportCompleted.current = "In Progress";

      checkProcessStatus();
      // setIsImportCompleted(responseJson.data)
      setOpenImportStatusDialog(true);
    }

  }


  const SendEmail = async (items: OTRModuleModelDTO) => {
    const result = await apiClient(`/OpenTaxReport/SendMissingFieldEmail`, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify(items), // Send as an object with 'field' property
    });

    return result;
  }

  const deleteOTRData = async (items: OTRModuleModel[]) => {
    // for (const item of items) {
    setloading(true);
    await apiClient(`/OpenTaxReport/Delete`, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify(items),
    }).then((response) => {
      if (!response) return
      Swal.fire({
        title: "Data Successfully Deleted",
        text: "",
        icon: "success",
        confirmButtonText: "OK",
      });
      setloading(false)
    })
    // }
  }

  const offSetOTRData = async (items: OTRModuleModel[]) => {
    await apiClient(`/OpenTaxReport/Offset`, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify(items),
    }).then((response) => {
      setloading(false)
    })
  }
  const approveOTRData = async (items: OTRModuleModel[]) => {
    // Console logging for debugging
    const requestPayload = {
      url: '/OpenTaxReport/Approve',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(items),
    };
    
    console.log('=== OpenTaxReport Approve Request Debug ===');
    console.log('Full request payload:', requestPayload);
    console.log('Authentication token:', token);
    console.log('Items being approved:', items);
    console.log('Request body (stringified):', JSON.stringify(items));
    console.log('==========================================');
    
    try {
      const response = await apiClient(`/OpenTaxReport/Approve`, {
        method: "POST",
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(items),
      });
      setloading(false);
      if (!response || response.status === false || response.ok === false) {
        return null;
      }
      return response.data ?? null;
    } catch (err) {
      console.error('OpenTaxReport Approve error:', err);
      setloading(false);
      return null;
    }
  }


  const handleSortChange = (field: string, direction: string) => {
    setSortField(field);
    setSortDirection(direction);
    fetchOTRData({
      pageNumber: currentPage + 1,
      pageSize: pageSize,
      sort: direction,
      field: field,
      filters: filterModel
    });
  };


  const getDataOTR = async () => {
    fetchOTRData({
      pageNumber: currentPage + 1, // API uses 1-based indexing
      pageSize: pageSize,
      sort: sortDirection,
      field: sortField,
      filters: filterModel
    })
  }
  const partnerDataDetails: PartnerDataType = {
    customerName: "",
    partnersId: 0
  }
  const [excelFormatList, setExcelFormatList] = useState<PartnerDataType[]>([partnerDataDetails])
  const [excelFormatListName, setExcelFormatListName] = useState<string[]>([])
  const fetchCustomer = async () => {
    return apiClient("/Partners/getPartners", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return
        // Do something with the response
        const update = responseJson.data.map((item: any) => item.customerName)
        setExcelFormatList(responseJson.data);
        setExcelFormatListName(update);
        return update
      })
  };

  const fetchStateList = async () => {
    return await apiClient('/States/getStates', {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    }).then(responseJson => {
      if (!responseJson || !responseJson.data) return
      // responseJson.data
      const stateList = responseJson.data.map((s: any) => s.postalAbbv) || []

      setStateList(stateList)
    })
  }

  const fetchTaxandFeeList = async () => {
    return await apiClient('/TaxesAndFees/getAllTaxAndFeesNamesWithStates', {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    }).then(responseJson => {
      if (!responseJson) return
      const taxAndFeesList = responseJson.data
      const res = taxAndFeesList.reduce((arr: any, item: any) => {
        const key = item?.state?.postalAbbv
        if (!key) return arr
        const value = item?.taxName
        if (!value) return arr

        arr[key] = arr[key] || ["Surplus Lines Tax"]
        if (!arr[key].includes(value)) {
          arr[key].push(value)
        }
        return arr
      }, {})

      res['all'] = res['null'] = res['undefined'] = ["Surplus Lines Tax"]

      setTaxFeeList(res)
    })
  }

  // // const [taxandFeesList, settaxandFeesList] = useState<string[]>([])
  // const fetchTaxandFees = async (items: string) => {
  //   setloading(true);
  //     const res = await apiClient(`/OpenTaxReport/GetTaxandFeeNameByState?HomeState=${items}`, {
  //       method: "POST",
  //       headers: new Headers({
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //       }),
  //     });

  //     setloading(false);
  //     if (!res || !res.data) return
  //     const taxAndFeesList = res.data;
  //     // settaxandFeesList(taxAndFeesList);
  //     return taxAndFeesList
  // };

  const handleCloseImportStatusDialog = () => {
    setOpenImportStatusDialog(false);
    getDataOTR();
    isImportCompleted.current = "";
  };

  // Archived with import duplicate-detection disable (2026-07-29 Dream Team).
  /*
  const runPendingImport = useCallback(async (restoredCustomerPolicyIds?: number[]) => {
    const pending = pendingImportRef.current;
    if (!pending) return;
    pendingImportRef.current = null;

    // Do NOT import any rows returned by CheckRemovedQueue (matched Removed Queue rows).
    // Only import rows that were not in the Removed Queue. Restore only moves them to Outstanding queues.
    const matchedItems = pending.matchedItems ?? [];
    const matchedIndices = new Set(
      matchedItems
        .map((m) => (m.importRowIndex != null ? Number(m.importRowIndex) - 1 : -1))
        .filter((i) => i >= 0)
    );
    const itemsToImport = pending.items.filter((_, index) => !matchedIndices.has(index));

    const file = pending.file ?? null;
    if (itemsToImport.length === 0) {
      getDataOTR();
      return;
    }
    if (file) {
      await updateOTRData(itemsToImport, 1, file);
    } else {
      await updateOTRData(itemsToImport, 1);
    }
    getDataOTR();
  }, []);

  const restoreFromRemovedQueue = useCallback(async (customerPolicyIds: number[]) => {
    if (!customerPolicyIds || customerPolicyIds.length === 0) return;
    await apiClient("/OpenTaxReport/RestoreFromRemovedQueue", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify({ customerPolicyIds }),
    });
  }, [token]);

  const handleRestoreSelected = useCallback(async (customerPolicyIds: number[]) => {
    await restoreFromRemovedQueue(customerPolicyIds);
    await runPendingImport(customerPolicyIds);
  }, [restoreFromRemovedQueue, runPendingImport]);

  const handleRestoreAll = useCallback(async () => {
    await restoreFromRemovedQueue(removedQueueMatchedIds);
    await runPendingImport(removedQueueMatchedIds);
  }, [restoreFromRemovedQueue, removedQueueMatchedIds, runPendingImport]);

  const handleDontRestore = useCallback(() => {
    runPendingImport();
  }, [runPendingImport]);
  */
  useEffect(() => {

    fetchCustomer()
    fetchTaxandFeeList()
    fetchStateList()
    // fetchTaxandFees("")
    getDataOTR()
  }, []);




  const determineExcel = (xlsHeaders: (string | undefined)[]) => {
    return excelExportTypes[0]
    let excelType = -1
    xlsHeaders.forEach((header) => {
      if (!header) return
      const column = determineColumnFromList(header)
      if (!column || !column.excelType) return
      if (excelType >= 0 && column.excelType !== excelType) {
        excelType = 0
      } else {
        excelType = column.excelType
      }
    })
    if (excelType < 0) excelType = 0

    const excelItem = excelExportTypes.find(item => item.excelType === excelType) ?? excelExportTypes[0]
    return excelItem
  }

  const handlePageChange = (val: number) => {
    setCurrentPage(val)
    fetchOTRData({ 
      pageSize: pageSize, 
      pageNumber: val + 1,  // Convert 0-based to 1-based for API
      sort: sortDirection, 
      field: sortField,
      filters: filterModel
    })
  }
  const handlePageSizeChange = (val: number) => {
    if (val <= 0) return
    setPageSize(val)
    setCurrentPage(0) // Reset to first page when changing page size
    fetchOTRData({ 
      pageSize: val, 
      pageNumber: 1, 
      sort: sortDirection, 
      field: sortField,
      filters: filterModel
    })
  }
  const formatCurrency = (value: number): string => {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  // List of fields that need currency formatting
  const currencyFields = ['taxAmt', 'grossPremium', 'taxableFees', 'taxBalance', 'nonAdmittedPremium', 'nonTaxableFees'];
  const dateInvoiceAddedField = 'dateInvoiceAdded';
  const exportXlsx = async (items: OTRModuleModel[], excelExportType: number) => {
    if (items.length === 0) {
      return
    }
    const excelItem = excelExportTypes.find(x => x.excelType === excelExportType)
    if (!excelItem) return

    const updates1: { [x: string]: any[] } = {}
    // excelItems.forEach(ex => {
    const headerRow = excelItem.columnOrder.map(idx => columnList[idx].xlsHeader[0])
    updates1[excelItem.name] = [headerRow]
    // })

    items.forEach(item => {
      const xlsHeaders: string[] = []
      Object.keys(item).map((field) => {
        if (!item[field as keyof OTRModuleModel]) return
        const column = columnList.find(col => col.field === field)
        if (!column?.xlsHeader) return
        xlsHeaders.push(column.xlsHeader[0])
      })
      // const excelItem = determineExcel(xlsHeaders)
      const update1 = excelItem.columnOrder.map(idx => {
        const column = columnList[idx]
        const field = column.field as keyof OTRModuleModel
        let value = item[field]
        
        // Apply default values for blank fields during export
        if (value === undefined || value === null || value === '') {
          switch (field) {
            case 'homeState':
              value = (item as any).stateName;
              break;
            case 'taxType':
              value = (item as any).taxName;
              break;
            case 'carrier':
              value = (item as any).carrierName;
              break;
            case 'transactionType':
              value = (item as any).transactionTypeName;
              break;
            case 'naic':
              value = (item as any).naicNumber;
              break;
            case 'client':
              value = (item as any).customerName;
              break;
            default:
              return; // Skip other blank fields
          }
        }
        
        if (value === undefined || value === null) return
        switch (column.inputType) {
          case 'string':
            if (field === dateInvoiceAddedField) {
              return formatUtcToLocal(value as string, 'MM-DD-YYYY HH:mm');
            }
            return value.toString()
          case 'date':
            return value ? formatUtcToLocal(value as string, 'MM-DD-YYYY HH:mm') : undefined;
          case 'number':
            if (currencyFields.includes(field as string)) {
              return CorrectedformatCurrency(value.toString());
            }
            return +value;
          case 'bool':
            return !!value
          default:
            return value
        }
      })
      updates1[excelItem.name].push(update1)
    })

    // excelItems.forEach(excelItem => {
    if (!updates1[excelItem.name] || updates1[excelItem.name].length <= 1) return
    const timeStamp = moment().format('YYYY-M-D')
    return writeXlsxFile(updates1[excelItem.name], `${timeStamp}_${excelItem.name}.xlsx`)
    // })
  }
  const handleExportXlsx = async (items: OTRModuleModel[]) => {
    // Export as 'OpenTaxReport'
    exportXlsx(items, excelExportTypes[0].excelType)
  }

  const isXlsxHeaderExist = (xlsHeaders: string[], fieldName: string) => {
    const columns = columnList.filter(col => col.field === fieldName)
    if (!columns.length) return false
    const possibleHeaders = (columns.map(c => c.xlsHeader)).flat(1)
    const columnHeader = possibleHeaders.map(compactString).map(compactString)
    const headerIndex = xlsHeaders.findIndex((header: string) => columnHeader.includes(compactString(header)))
    return headerIndex > -1
  }

  const determineColumnFromList = (header: string) => {

    const column = columnList.find(column => {
      const headerKey = compactString(column.xlsHeader[0])
      const headerCompact = compactString(header)
      if (headerKey && headerCompact) {
        // const searchedByKey = headerCompact.includes(headerKey)
        // if (!searchedByKey) {
        return column.xlsHeader.map(compactString).includes(compactString(headerCompact))
        // }
        // return true
      }
      return false
    })

    return column
  }

  const handleImportXlsx = async (file: File, client: string) => {
    setloading(true)
    if (status == false) {
      setstatus(true)
    }
    const sheetsData = await readXlsxFile(file)
    if (!sheetsData || Object.keys(sheetsData).every((sheetName: string) => !sheetsData[sheetName] || sheetsData[sheetName].length <= 1)) {
      alert("The file is empty or invalid. Please check the file.");
      setloading(false)
      return;
    }

    const missingHeaderList: string[] = []
    const updateList: OTRModuleModel[] = []

    let missingUpdates: { [key: string]: OTRModuleModel[] } = {
      client_Required: [],
      grossPremium_Required: [],
      SLTax_StampFee_0: [],
      TaxAmt_TaxBase_Required: [],
      invalid_Dates: [],
    }

    for (const sheetName in sheetsData) {
      const sheet = sheetsData[sheetName]
      const xlsHeaders = sheet[0]
      if (!xlsHeaders || xlsHeaders.length < 1) continue
      // _rowNum is a number matched with excel file's row number. (debug purpose)
      xlsHeaders[0] = '_rowNum'

      const content = sheet.slice(1).filter((item: any) => {
        if (!item || item.length <= 1) return false
        return hasOtrImportExcelRowData(xlsHeaders, item)
      })

      // const excelItem = determineExcel(xlsHeaders)
      let updates: OTRModuleModel[] = []


      // const hasIntrepidClient = content.some((item: any) => item.includes('Intrepid Direct Insurance Agency, LLC' || 'Intrepid Direct Insurance Agency LLC'));
      // if (hasIntrepidClient && !xlsHeaders.includes('taxType')) {
      //   xlsHeaders.push('taxType');
      // }
      xlsHeaders.forEach((header: string, idx: number) => {
        const column = determineColumnFromList(header)
        if (!column && header) {
          missingHeaderList.push(header);
        }
      });

      content.forEach((item: any, index: number) => {
        var isReturn = 0;

        const update: OTRModuleModel = {}

        update.NewOpenTaxReportId = 0
        var taxType: string | undefined;
        // if (hasIntrepidClient && item.includes('Intrepid Direct Insurance Agency, LLC')) {
        //   const coverageIndex = xlsHeaders.indexOf('Coverage');

        //   if (coverageIndex !== -1) {
        //     taxType = item[coverageIndex];
        //   }
        // }
        xlsHeaders.forEach((header: string, idx: number) => {
          const column = determineColumnFromList(header)
          if (!column) {
            // Ignored when excel header name is not registered (missingHeaders)
            return
          }

          if (column.field === 'taxType') {
            if (!item[idx]) {
              return;
            }
            item[idx] = item[idx].split('-').at(-1).trim();
            if (item[idx].trim().toLowerCase() == 'state tax') {
              item[idx] = 'Surplus Lines Tax'
            }
          }
          const field = column.field as keyof OTRModuleModel
          switch (column.inputType) {
            case 'string':
              // if (hasIntrepidClient && field === 'taxType') {
              //   break;
              // }
              update[field] = item[idx]
              if (similarList[field]) {
                // Convert to string before calling compactString to handle numbers
                const itemValueStr = item[idx] != null ? String(item[idx]) : '';
                const scen = similarList[field].find(scen => scen.possibleValues.map(compactString).includes(compactString(itemValueStr)))
                update[field] = (scen?.value ?? itemValueStr) as any
              } else {
                update[field] = item[idx]?.toString()
              }
              break;


            case 'date': {
              const raw = item[idx];
              const dateString = formatOtrImportDate(raw);
              if (dateString) {
                update[field] = dateString as any;
              } else if (!isOtrImportDateCellBlank(raw)) {
                update[field] = String(raw).trim() as any;
              }
              break;
            }


            case 'number':
              const nVal = (item[idx] === "" || item[idx] === undefined) ? undefined : (+item[idx])?.toFixed(2).replace(/\.?0+$/, '')
              update[field] = nVal as any
              break;
            case 'bool':
              update[field] = (!!item[idx]) as any
              break;
            default:
              update[field] = item[idx]?.toString()
              break;
          }
        })

        // update['filerNotes'] = ''
        update['dateInvoiceAdded'] = new Date().toISOString()

        // If "transEffDate" header not exist, update it from "effDate"
        if (!isXlsxHeaderExist(xlsHeaders, 'transEffDate') && isXlsxHeaderExist(xlsHeaders, 'effDate')) {
          update['transEffDate'] = update['effDate']
          // update['clientDiv'] = 'Vally View'
        }
        // If "policyEffDate" header not exist, update it from "effDate"
        if (!isXlsxHeaderExist(xlsHeaders, 'policyEffDate') && isXlsxHeaderExist(xlsHeaders, 'effDate')) {
          update['policyEffDate'] = update['effDate']
          // update['clientDiv'] = 'Vally View'
        }
        // If "client" header not exist, update value
        if (isEmptyOrUndefined(update['client'])) {
          update['client'] = client
        } else {
          const matchedClient = clientList.find(c => c.possibleValues.some(val => compactString(val) === compactString(update['client'])))
          if (matchedClient) {
            update['client'] = matchedClient.value
          }
          // Keep full client name for display in missing file when client is incorrect
          const originalClientName = (update['client'] ?? '').toString().trim();
          const clientForLookup = originalClientName.length > 10
            ? originalClientName.slice(0, -6).trim()
            : originalClientName;
          const isExistClient = excelFormatList.findIndex(c =>
            c.customerName.toLowerCase().includes(clientForLookup.toLowerCase())
          );
          if (isExistClient == -1) {
            missingUpdates.client_Required.push({ ...update, client: originalClientName, incorrectField: 'client is incorrect' })
            // return
            isReturn++;
          } else {
            update['client'] = excelFormatList[isExistClient].customerName;
          }
        }
        // If "effDate" exist, update "clientDiv" value as "Vally View"
        // const Client = update['client']
        // if (!isXlsxHeaderExist(xlsHeaders, 'policyEffDate') && Client === 'Cardigan General Insurance Services' || Client === 'Cardigan General Insurance Services, LLC') {
        //   update['clientDiv'] = 'Vally View'
        // }


        const singlePartnerData = excelFormatList.find((p: PartnerDataType) => p.customerName === client);
        update['partnersId'] = singlePartnerData?.partnersId;

        const invalidDateFields = collectInvalidOtrImportDateFields(
          xlsHeaders,
          item,
          determineColumnFromList
        );
        if (invalidDateFields.length > 0) {
          missingUpdates.invalid_Dates.push({
            ...update,
            incorrectField: formatInvalidOtrImportDateMessage(invalidDateFields),
          });
          isReturn++;
        }

        // If "grossPremium" is null or 0, ignore update
        if (isNanOrZero(update['grossPremium'])) {
          missingUpdates.grossPremium_Required.push({ ...update, incorrectField: 'grossPremium is required' })
          // return
          isReturn++;
        }


        if (isXlsxHeaderExist(xlsHeaders, 'taxSL') && isXlsxHeaderExist(xlsHeaders, 'stampFee')) {
          // If "taxSL" and "stampFee" fields exists
          if (!isNanOrZero(update['taxSL'])) {
            // const newUpdate = JSON.parse(JSON.stringify(update));
            update['taxType'] = 'Surplus Lines Tax';
            // update['taxAmt'] = newUpdate['taxSL'];
            // updates = [...updates, newUpdate];
          }

          if (!isNanOrZero(update['stampFee'])) {
            // const newUpdate = JSON.parse(JSON.stringify(update));
            update['taxType'] = 'Stamping Fee';
            // update['taxAmt'] = newUpdate['stampFee'];
            // updates = [...updates, newUpdate];
          }
          // Ignore when taxSL or stampFee = 0
          if ((isNanOrZero(update['taxSL'])) || (isNanOrZero(update['stampFee']))) {
            missingUpdates.SLTax_StampFee_0.push({ ...update, incorrectField: `"S/L Tax" or "Stamp Fee" should not be 0` })
            // return
            isReturn++;
          }
        }
        else if (isXlsxHeaderExist(xlsHeaders, 'taxAmt') && !isNanOrZero(update['taxAmt'])) {
          if (isReturn > 0) {
            return
          }
          // If "taxAmt" field exists
          if (isReturn > 0) {
            return
          }
          updates = [...updates, update]
          return
        } else {
          // Ignore when taxAmt = 0
          missingUpdates.TaxAmt_TaxBase_Required.push({ ...update, incorrectField: `"Tax Amount" or "TaxAmt" or "Tax Base" is required` })
          // return
          isReturn++;
        }
      })

      const missingCounts = Object.values(missingUpdates).reduce((sum, arr) => sum + arr.length, 0)


      let index = 0;
      while (index < updates.length) {
        const element = updates[index];
        const transactionType = element['transactionType'];
        // Convert to string to handle both numbers and strings
        const transactionTypeStr = transactionType != null ? String(transactionType) : '';
        if (transactionTypeStr && transactionTypeStr.toLowerCase().includes('endorsement')) {
          updates[index].transactionType = 'Endorsement';
        } else {
          // If transaction type matches the list, use the matched standard value
          const matchedTransType = transactionTypeList.find(tr => 
            tr.possibleValues.some(pv => compactString(pv) === compactString(transactionTypeStr)) || 
            compactString(tr.value) === compactString(transactionTypeStr)
          );
          if (matchedTransType) {
            updates[index].transactionType = matchedTransType.value;
          }
          // If no match, keep the original transactionType from Excel (will be highlighted red in UI)
        }
        if (compactString(element['carrier']) === 'lloyd' || element['carrier'] === "Lloyd's") {
          updates[index].carrier = "Certain Underwriters at Lloyd's of London";
        }

        //Case for Venbrook Insurance Services: when client name came  as VA Changing it to Venbrook Insurance Services
        const client = element['client'];
        if (client === 'VA') {
          updates[index].client = 'Venbrook Insurance Services';
        }

        if (client === 'Cardigan General Insurance Services' || client === 'Cardigan General Insurance Services, LLC') {
          const insuredName = element['insuredName'];
          if (insuredName !== undefined && insuredName.toLowerCase().includes('record(s)')) {
            updates.splice(index, 1);
            continue;
          }
        }

        const taxType = element['taxType'];
        const matchedTaxType = taxTypeList.find(tax => tax.possibleValues.some(value => compactString(value) === compactString(taxType)));
        if (matchedTaxType) {
          updates[index].taxType = matchedTaxType.value;
        }

        const invoiceNumber = element['invoiceNumber'];
        // if (!isInvoiceNumber(invoiceNumber)) {
        //   updates[index].invoiceNumber = undefined;
        // }
        index++;
      }

      updateList.push(...updates)

    }

    const uniqueMissingHeaders = Array.from(new Set(missingHeaderList));
    if (uniqueMissingHeaders.length > 0) {
      try {
        await SendEmail({ field: uniqueMissingHeaders, fileName: file.name });
      } catch (err) {
        console.error("SendMissingFieldEmail error:", err);
      }
    }

    setCurrentPage(0)

    // const endorsementRecords = updateList.filter(record => record.transactionType === "Endorsement");
    // const remainingRecords = updateList.filter(record => record.transactionType !== "Endorsement");

    // const uniqueArray = removeDuplicatesonImport(updateList);
    const uniqueArray = updateList;

    const missingRecords = [
      ...missingUpdates.client_Required,
      ...missingUpdates.grossPremium_Required,
      ...missingUpdates.SLTax_StampFee_0,
      ...missingUpdates.TaxAmt_TaxBase_Required,
      ...missingUpdates.invalid_Dates,
    ];

    /** Original removed-queue payload (unchanged matching rules on server). */
    const buildRemovedQueuePayload = (items: OTRModuleModel[]) =>
      items.map((item) => ({
        policyNumber: item.policyNumber,
        invoiceNumber: item.invoiceNumber,
        stateId: item.stateId,
        stateCode: item.homeState ?? (item as any).stateCode ?? "",
        client: item.client,
        transactionTypeId: item.transactionTypeId,
        transactionType: item.transactionType,
        taxType: item.taxType,
        taxAmt: item.taxAmt,
        grossPremium: item.grossPremium,
        invDate: item.invDate,
        effectiveDate: item.policyEffDate || (item as any).effDate,
        expirationDate: item.policyExpDate,
      }));

    const buildMissingFile = async () => {
      if (missingRecords.length === 0) return null;
      return (await exportXlsx(missingRecords, excelExportTypes[1].excelType)) ?? null;
    };

    const importItems = async (items: OTRModuleModel[], prebuiltFile?: File | null) => {
      const file = prebuiltFile !== undefined ? prebuiltFile : await buildMissingFile();

      if (items.length === 0 && !file) {
        getDataOTR();
        setloading(false);
        return;
      }

      if (file) {
        await updateOTRData(items, 1, file);
      } else {
        await updateOTRData(items, 1);
      }
      getDataOTR();
      setloading(false);
    };

    // OTR import duplicate-detection disabled 2026-07-29 (Dream Team).
    // Blocked/missed transactions outweigh rare true duplicates (caught downstream).
    // Import all parsed rows; skip in-file dialog + CheckImportDuplicates + CheckRemovedQueue
    // round-trips (API already short-circuits). Kept below for revisit with improved matching.
    await importItems(uniqueArray);
    /*
    const getMatchedIndices = (matches: Array<{ importRowIndex?: number }>) =>
      new Set(
        matches
          .map((m) => (m.importRowIndex != null ? Number(m.importRowIndex) - 1 : -1))
          .filter((i) => i >= 0)
      );

    const applyDuplicateSkip = (items: OTRModuleModel[], matches: MatchedExistingOtrItem[]) => {
      const skipIdx = getMatchedIndices(matches);
      return items.filter((_, idx) => !skipIdx.has(idx));
    };

    const excludeRemovedMatches = (items: OTRModuleModel[], matches: MatchedRemovedItem[]) => {
      const removedIdx = getMatchedIndices(matches);
      return items.filter((_, idx) => !removedIdx.has(idx));
    };

    const checkRemovedMatches = async (items: OTRModuleModel[]) => {
      const removedQueuePayload = buildRemovedQueuePayload(items);
      try {
        const checkRes = await apiClient("/OpenTaxReport/CheckRemovedQueue", {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }),
          body: JSON.stringify(removedQueuePayload),
        });
        return {
          matchedItems: (checkRes?.matchedItems ?? []) as MatchedRemovedItem[],
          matchedCustomerPolicyIds: (checkRes?.matchedCustomerPolicyIds ?? []) as number[],
        };
      } catch (err) {
        console.error("CheckRemovedQueue error:", err);
        return { matchedItems: [] as MatchedRemovedItem[], matchedCustomerPolicyIds: [] as number[] };
      }
    };

    const checkExistingDuplicates = async (items: OTRModuleModel[]) => {
      try {
        const dupPayload = buildOtrImportDuplicatePayload(items);
        const dupRes = await apiClient("/OpenTaxReport/CheckImportDuplicates", {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }),
          body: JSON.stringify(dupPayload),
        });
        return (dupRes?.matches ?? []) as MatchedExistingOtrItem[];
      } catch (err) {
        console.error("CheckImportDuplicates error:", err);
        return [] as MatchedExistingOtrItem[];
      }
    };

    let workingList = uniqueArray;

    const dupGroups = findInFileDuplicateGroups(workingList);
    if (dupGroups.length > 0) {
      const choice = await new Promise<"skip" | "all" | "cancel">((resolve) => {
        inFileDupResolverRef.current = resolve;
        setInFileDupGroups(dupGroups);
        setInFileDupDialogOpen(true);
      });
      if (choice === "cancel") {
        setloading(false);
        return;
      }
      if (choice === "skip") {
        workingList = filterInFileDuplicatesKeepFirst(workingList);
      }
    }

    const [dbMatches, removedRes] = await Promise.all([
      checkExistingDuplicates(workingList),
      checkRemovedMatches(workingList),
    ]);
    const hasDupMatches = dbMatches.length > 0;
    const hasRemovedMatches = removedRes.matchedItems.length > 0;

    if (hasDupMatches && hasRemovedMatches) {
      setloading(false);
      const combinedChoice = await new Promise<CombinedConflictChoice | "cancel">((resolve) => {
        combinedConflictResolverRef.current = resolve;
        setCombinedConflictDupMatches(dbMatches);
        setCombinedConflictRemovedItems(removedRes.matchedItems);
        setCombinedConflictTotalImport(workingList.length);
        setCombinedConflictDialogOpen(true);
      });
      if (combinedChoice === "cancel") {
        setloading(false);
        return;
      }
      setloading(true);

      let itemsAfterDup = workingList;
      if (combinedChoice.duplicateAction === "skip") {
        itemsAfterDup = applyDuplicateSkip(itemsAfterDup, dbMatches);
      }

      if (combinedChoice.removedAction === "restore_all") {
        await restoreFromRemovedQueue(removedRes.matchedCustomerPolicyIds);
      } else if (combinedChoice.removedAction === "restore_selected") {
        await restoreFromRemovedQueue(combinedChoice.selectedCustomerPolicyIds);
      }

      const finalItemsToImport = excludeRemovedMatches(itemsAfterDup, removedRes.matchedItems);
      await importItems(finalItemsToImport);
      return;
    }

    if (hasDupMatches) {
      const choice = await new Promise<"skip" | "all" | "cancel">((resolve) => {
        existingDupResolverRef.current = resolve;
        setExistingDupMatches(dbMatches);
        setExistingDupDialogOpen(true);
      });
      if (choice === "cancel") {
        setloading(false);
        return;
      }
      if (choice === "skip") {
        workingList = applyDuplicateSkip(workingList, dbMatches);
      }
    }

    if (hasRemovedMatches) {
      setRemovedQueueMatchedItems(removedRes.matchedItems);
      setRemovedQueueMatchedIds(removedRes.matchedCustomerPolicyIds);
      setRemovedQueueTotalImport(workingList.length);
      pendingImportRef.current = {
        items: workingList,
        file: await buildMissingFile(),
        matchedItems: removedRes.matchedItems,
      };
      setOpenRemovedQueueDialog(true);
      setloading(false);
      return;
    }

    await importItems(workingList);
    */
  }
  const removeDuplicates = (array: OTRModuleModel[]): OTRModuleModel[] => {
    const uniqueItems = array.reduce((acc, current) => {
      // Handle both NewOpenTaxReportId and newOpenTaxReportId (case variations)
      const id = current?.NewOpenTaxReportId || (current as any)?.newOpenTaxReportId;
      if (id !== undefined) {
        acc[id] = current;
      }
      return acc;
    }, {} as { [key: number]: OTRModuleModel });
    return Object.values(uniqueItems);
  }
  const removeDuplicatesonImport = (array: OTRModuleModel[]): OTRModuleModel[] => {
    const uniqueItems = array.reduce((acc, current) => {
      const key = `${current.invoiceNumber}_${current.policyNumber}_${current.homeState}_${current.insuredName}_${current.taxType}_${current.coverage}
      _${current.carrier}_${current.naic}_${current.nonAdmittedPremium}_${current.grossPremium}_${current.taxAmt}_${current.transactionType}
      _${current.nonTaxableFees}_${current.taxableFees}_${current.client}_${current.clientDiv}_${current.policyEffDate}_${current.policyExpDate}_${current.status}`;
      if (!acc[key]) {
        acc[key] = current;
      }
      return acc;
    }, {} as { [key: string]: OTRModuleModel });
    return Object.values(uniqueItems);
  };

  const handleRemoveItems = async (values: OTRModuleModel[]) => {
    const uniqueOpenTaxReportsArray = removeDuplicates(values);
    const deletedEntireCurrentPage = uniqueOpenTaxReportsArray.length >= dataOTR.length && currentPage > 0;
    const pageToShow = deletedEntireCurrentPage ? currentPage - 1 : currentPage;

    await deleteOTRData(uniqueOpenTaxReportsArray);

    if (deletedEntireCurrentPage) {
      setCurrentPage(pageToShow);
      await fetchOTRData({
        pageNumber: pageToShow + 1,
        pageSize: pageSize,
        sort: sortDirection,
        field: sortField,
        filters: filterModel,
      });
    } else {
      await getDataOTR();
    }
  }

  const handleOffsetItems = async (values: OTRModuleModel[]) => {
    setloading(true)
    await offSetOTRData(values)
    await getDataOTR()
    setloading(false)
  }
  const handleApproveItems = async (values: OTRModuleModel[]) => {
    if (!values.length) return
    const validTransactionTypes = ['New Business', 'Renewal Business', 'Audit', 'Endorsement', 'Reversal', 'Reinstatement', 'Cancellation'];
    const validItems = values.filter(item => {
      const transType = item.transactionType;
      return transType && validTransactionTypes.includes(transType);
    });

    const invalidItems = values.filter(item => {
      const transType = item.transactionType;
      return !transType || !validTransactionTypes.includes(transType);
    });

    // If no valid items to approve
    if (validItems.length === 0) {
      await Swal.fire({
        title: 'Cannot Approve',
        html: `<p>All ${invalidItems.length} selected item(s) have invalid Transaction Type.</p><p>Please update the Transaction Type to one of the following before approving:</p><p><strong>New Business, Renewal Business, Audit, Endorsement, Reversal, Reinstatement, Cancellation</strong></p>`,
        icon: 'error',
        confirmButtonColor: '#02A4E3',
        customClass: {
          confirmButton: 'btn-radius',
          popup: 'card-radius'
        }
      });
      return;
    }
    let confirmText = "You won't be able to revert this!";
    if (invalidItems.length > 0) {
      confirmText = `${validItems.length} item(s) will be approved. ${invalidItems.length} item(s) with invalid Transaction Type will be skipped.`;
    }

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: confirmText,
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Approve',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    })

    if (result.isConfirmed) {
      setloading(true)
      // Only approve valid items
      const uniqueOpenTaxReportsArray = removeDuplicates(validItems);

      const approveResult = await approveOTRData(uniqueOpenTaxReportsArray)
      getDataOTR()
      setSelectedRows([]);
      setSelectionModel([]);
      setloading(false)

      // Approval duplicate skip/popup disabled (MISC / Kelly 2026-08-05).
      // Do not flag or skip exact duplicates after import; caught downstream.
      // Archived below for revisit with improved matching. Active path: failure + invalid Transaction Type only.
      /*
      const requestedCount = uniqueOpenTaxReportsArray.length;
      const approvalCount = Number(approveResult?.approvalCount ?? 0);
      const duplicateCount = Number(approveResult?.duplicateCount ?? 0);
      const notApprovedCount = Math.max(0, requestedCount - approvalCount);

      if (approveResult == null) {
        await Swal.fire({
          title: 'Approval Failed',
          html: `<p>The approval request did not complete successfully. Please try again or contact support.</p>`,
          icon: 'error',
          confirmButtonColor: '#02A4E3',
          customClass: {
            confirmButton: 'btn-radius',
            popup: 'card-radius'
          }
        });
      } else if (duplicateCount > 0 || notApprovedCount > 0 || invalidItems.length > 0) {
        const parts: string[] = [
          `<p><strong>${approvalCount}</strong> item(s) approved successfully.</p>`,
        ];
        if (duplicateCount > 0) {
          parts.push(
            `<p><strong>${duplicateCount}</strong> item(s) were skipped as exact duplicates of existing filings.</p>`
          );
        } else if (notApprovedCount > 0) {
          parts.push(
            `<p><strong>${notApprovedCount}</strong> item(s) were not approved.</p>`
          );
        }
        if (invalidItems.length > 0) {
          parts.push(
            `<p><strong>${invalidItems.length}</strong> item(s) were skipped due to invalid Transaction Type.</p>`
          );
        }
        await Swal.fire({
          title: 'Approval Complete',
          html: parts.join(''),
          icon: 'info',
          confirmButtonColor: '#02A4E3',
          customClass: {
            confirmButton: 'btn-radius',
            popup: 'card-radius'
          }
        });
      }
      */
      if (approveResult == null) {
        await Swal.fire({
          title: 'Approval Failed',
          html: `<p>The approval request did not complete successfully. Please try again or contact support.</p>`,
          icon: 'error',
          confirmButtonColor: '#02A4E3',
          customClass: {
            confirmButton: 'btn-radius',
            popup: 'card-radius'
          }
        });
      } else if (invalidItems.length > 0) {
        await Swal.fire({
          title: 'Approval Complete',
          html: `<p><strong>${uniqueOpenTaxReportsArray.length}</strong> item(s) submitted for approval.</p><p><strong>${invalidItems.length}</strong> item(s) were skipped due to invalid Transaction Type.</p>`,
          icon: 'info',
          confirmButtonColor: '#02A4E3',
          customClass: {
            confirmButton: 'btn-radius',
            popup: 'card-radius'
          }
        });
      }
    }

  }

  const getOptions = (field: string) => {
    switch (field) {
      case 'excelFormatList':
        return excelFormatListName
    }
    return []
  }
  const fetchOptions = async (field: string, rowVal?: any) => {
    switch (field) {
      case 'taxType':
        const data = taxFeeList[String(rowVal.homeState)]
        return data
      // const data = await fetchTaxandFees(rowVal.homeState)
      // return data
      case 'homeState':
        return stateList
    }
    return []
  }

  const checkIsValid = (field: string, rowVal: any) => {
    switch (field) {
      case 'taxType':
        if (!rowVal || !rowVal.taxType) return false
        return taxFeeList[String(rowVal.homeState)]?.includes(rowVal.taxType);

      case 'homeState':
        if (!rowVal || !rowVal.homeState) return false
        return stateList?.includes(rowVal.homeState)
    }
    return false

  }
  const handleItemChange = async (item: OTRModuleModel) => {
    await updateOTRData([item], 0);
    //getDataOTR()
    // window.location.reload();
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
        {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      </div>
      <div style={{ height: 'calc(100vh - 130px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 2,
            borderBottom: '1px solid #e2e8f0',
            backgroundColor: '#fafbfc',
            minHeight: 70,
            mb: 3,
            marginLeft: { xs: '-24px', md: '0px' },
            marginRight: { xs: '-24px', md: '0px' },
          }}
        >
          <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
            Open Tax Report
          </h4>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} />
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column' }}>
          <OTRModuleList
            listData={dataOTR}
            pageSize={pageSize}
            currentPage={currentPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            onSortChange={handleSortChange}
            getOptions={getOptions}
            fetchOptions={fetchOptions}
            checkIsValid={checkIsValid}
            onItemChange={handleItemChange}
            onImportXlsx={handleImportXlsx}
            onExportXlsx={handleExportXlsx}
            onRemoveItems={handleRemoveItems}
            onOffsetItems={handleOffsetItems}
            onApproveItems={handleApproveItems}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            selectionModel={selectionModel}
            setSelectionModel={setSelectionModel}
            fetchData={getDataOTR}
            sortModel={sortModel}
            setSortModel={setSortModel}
            status={status}
            setStatus={setstatus}
            isImportCompleted={isImportCompleted.current}
            filterModel={filterModel}
            setFilterModel={setFilterModel}
            onFilterChange={handleFilterModelChange}
          />
          <ImportStatusDialog
            open={openImportStatusDialog}
            onClose={handleCloseImportStatusDialog}
            isImportCompletedRef={isImportCompleted} />
          {/* OTR import duplicate-detection disabled 2026-07-29 (Dream Team) — restore with imports/state above.
          <OTRRemovedQueueRestoreDialog
            open={openRemovedQueueDialog}
            onClose={() => setOpenRemovedQueueDialog(false)}
            matchedItems={removedQueueMatchedItems}
            matchedCustomerPolicyIds={removedQueueMatchedIds}
            totalImportCount={removedQueueTotalImport}
            onRestoreSelected={handleRestoreSelected}
            onRestoreAll={handleRestoreAll}
            onDontRestore={handleDontRestore}
            loading={loading}
          />
          <OTRImportInFileDuplicateDialog
            open={inFileDupDialogOpen}
            groups={inFileDupGroups}
            onSkipDuplicates={() => finishInFileDuplicateChoice("skip")}
            onImportAll={() => finishInFileDuplicateChoice("all")}
            onCancel={() => finishInFileDuplicateChoice("cancel")}
          />
          <OTRImportExistingDuplicateDialog
            open={existingDupDialogOpen}
            matches={existingDupMatches}
            onSkipMatched={() => finishExistingDuplicateChoice("skip")}
            onImportAll={() => finishExistingDuplicateChoice("all")}
            onCancel={() => finishExistingDuplicateChoice("cancel")}
          />
          <OTRImportCombinedConflictDialog
            open={combinedConflictDialogOpen}
            duplicateMatches={combinedConflictDupMatches}
            removedMatches={combinedConflictRemovedItems}
            totalImportCount={combinedConflictTotalImport}
            onContinue={(choice) => finishCombinedConflictChoice(choice)}
            onCancel={() => finishCombinedConflictChoice("cancel")}
            loading={loading}
          />
          */}
        </Box>
      </div>
    </LocalizationProvider>
  )
}
